export var ViewBackgroundFillType;
(function (ViewBackgroundFillType) {
    ViewBackgroundFillType[ViewBackgroundFillType["SolidColor"] = 0] = "SolidColor";
    ViewBackgroundFillType[ViewBackgroundFillType["Image"] = 1] = "Image";
    ViewBackgroundFillType[ViewBackgroundFillType["Graph"] = 2] = "Graph";
})(ViewBackgroundFillType || (ViewBackgroundFillType = {}));
